var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('poverty-visualization',{attrs:{"charts":_vm.charts,"area-chart":_vm.areaChart,"line-chart":_vm.lineChart,"title":_vm.title,"y-domain":_vm.yDomain}})}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-493cbec1","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/Components/Visualizations/LaborParticipationVisualization.vue
// module id = 186
// module chunks = 0